/**
 * Albanian content bundle — mirrors en.js exactly.
 * Tone: premium, editorial, formal address ("Ju").
 *
 * Note on terminology: established marketing loanwords (content, branding,
 * social media, reels, feed, engagement) are kept as-is, because that is how
 * the industry actually speaks in Albanian. Everything else is translated.
 */

const sq = {
  code: 'sq',
  htmlLang: 'sq',
  ogLocale: 'sq_AL',
  intlLocale: 'sq-AL',
  label: 'Shqip',
  shortLabel: 'AL',

  common: {
    bookConsultation: 'Rezervo një konsultë',
    bookCall: 'Rezervo një bisedë',
    exploreServices: 'Shiko shërbimet',
    exploreTheServices: 'Shiko shërbimet',
    whatsapp: 'WhatsApp',
    whatsappLong: 'Shkruaj në WhatsApp',
    learnMore: 'Mëso më shumë',
    viewAllServices: 'Shiko të gjitha shërbimet',
    inquireNow: 'Kërko tani',
    email: 'E-mail',
    placeholder: 'Vend i lirë',
    or: 'ose',
    scroll: 'Rrëshqit',
    sending: 'Po dërgohet…',
    tryAgain: 'Provoni përsëri',
  },

  whatsappMessage:
    'Përshëndetje Romilda, gjeta faqen tuaj dhe do të dëshiroja të bisedoja për markën tim.',

  nav: {
    home: 'Ballina',
    services: 'Shërbimet',
    about: 'Rreth meje',
    contact: 'Kontakt',
  },

  header: {
    openMenu: 'Hap menynë',
    closeMenu: 'Mbyll menynë',
    primaryNavLabel: 'Kryesore',
    mobileNavLabel: 'Mobile',
    languageGroupLabel: 'Gjuha',
    switchTo: 'Ndrysho gjuhën',
  },

  footer: {
    tagline:
      'Një agjenci premium e marketingut dixhital për marka me shije. Strategji e përmbajtjes, rritje në rrjetet sociale dhe identitet vizual — të ndërtuara me përpikëri redaksionale dhe të matura në rezultate.',
    navigate: 'Navigim',
    servicesHeading: 'Shërbimet',
    contactHeading: 'Kontakt',
    rights: 'Të gjitha të drejtat e rezervuara.',
    madeBy: 'Realizuar nga',
    onInstagram: 'në Instagram',
  },

  statsBand: {
    eyebrow: 'Numrat',
  },

  stats: [
    {
      value: '500.000+',
      label: 'Shikime të gjeneruara në muaj',
      note: 'Nëpër llogari dhe kampanja të menaxhuara',
      testId: 'home-stats-views',
    },
    {
      value: '160.000+',
      label: 'Llogari të arritura në muaj',
      note: 'Shtrirje organike, pa shkurtime me pagesë',
      testId: 'home-stats-reach',
    },
    {
      value: '100%',
      label: 'Strategji të personalizuara',
      note: 'Kurrë të gatshme, kurrë të ricikluara',
      testId: 'home-stats-tailored',
    },
  ],

  marquee: [
    'Strategji e përmbajtjes',
    'Rritje në rrjetet sociale',
    'Identitet vizual',
    'Drejtim redaksional',
    'Pozicionim i markës',
    'Strategji dixhitale',
  ],

  services: [
    {
      slug: 'social-media-management',
      number: '01',
      icon: 'Sparkles',
      title: 'Menaxhim i rrjeteve sociale',
      short:
        'Menaxhim strategjik i llogarive, rritje organike dhe strategji e angazhimit — të mbuluara nga fillimi në fund.',
      overview:
        'Marrim përgjegjësi të plotë për prezencën tuaj: kalendarin, tekstet, komunitetin, ritmin. Çdo postim zë vendin e vet me qëllim, që llogaria juaj të rritet e të mos qëndrojë vetëm aktive.',
      who: [
        'Sipërmarrës që nuk kanë më kohë për postime të përditshme',
        'Marka me produkte të shkëlqyera dhe një feed të papërputhshëm',
        'Ekipe që duan t’i dorëzojnë ritmin duarve të sigurta',
      ],
      outcomes: [
        'Një ritëm i qëndrueshëm publikimi që ndërtohet muaj pas muaji',
        'Shtrirje organike dhe rritje ndjekësish nga audienca e duhur',
        'Angazhim që kthehet në kërkesa, jo vetëm në pëlqime',
      ],
      includes: [
        'Kalendar mujor i përmbajtjes, përfshirë planifikimin dhe publikimin',
        'Tekste dhe copywriting në zërin e markës tuaj',
        'Menaxhim i komunitetit dhe strategji e angazhimit',
        'Strategji për hashtag, fjalë kyçe dhe zbulueshmëri',
        'Raportim mujor i performancës me interpretim',
      ],
    },
    {
      slug: 'content-strategy-aesthetic',
      number: '02',
      icon: 'LayoutTemplate',
      title: 'Strategji e përmbajtjes & estetikë',
      short:
        'Drejtim vizual dhe tekstual i nivelit të lartë — që çdo postim të meritojë vendin e vet.',
      overview:
        'Shumica e markave nuk kanë problem me përmbajtjen, kanë problem me drejtimin. Ne përcaktojmë shtyllat e përmbajtjes, gjuhën vizuale dhe strukturat narrative që e bëjnë planifikimin të lehtë dhe feed-in tuaj të panjollosur.',
      who: [
        'Marka me përmbajtje të dalë mode, të shpërndarë ose jashtë identitetit',
        'Biznese që postojnë rregullisht pa rezultat të matshëm',
        'Sipërmarrës që duan njëkohësisht shije dhe strukturë',
      ],
      outcomes: [
        'Një drejtim i qartë përmbajtjeje që mund t’i shërbejë çdo brifi',
        'Shtylla përmbajtjeje që e bëjnë planifikimin të shpejtë, jo të mundimshëm',
        'Një feed që lexohet i qëllimshëm, redaksional dhe premium',
      ],
      includes: [
        'Kuadër për shtyllat e përmbajtjes',
        'Drejtim vizual dhe moodboard',
        'Art direction redaksional për foto dhe video',
        'Struktura për hook, tekste dhe storytelling',
        'Një plan përmbajtjeje 30-ditor, i zbatueshëm menjëherë',
      ],
    },
    {
      slug: 'visual-identity-branding',
      number: '03',
      icon: 'Gem',
      title: 'Identitet vizual & branding',
      short:
        'Zhvillim i plotë i markës — pozicionim, familje logosh, paletë ngjyrash dhe udhëzues.',
      overview:
        'Identiteti nuk është një logo. Është arsyeja pse dikush mendon se ju vlen më shumë, para se ta thoni një fjalë. Ne ndërtojmë sistemin e plotë dhe ju dorëzojmë udhëzuesin për t’i mbrojtur.',
      who: [
        'Marka të reja që duan të nisin siç duhet',
        'Marka të konsoliduara që e kanë kaluar pamjen e tyre të fillimit',
        'Marka personale në rrugën drejt një pozicionimi më premium',
      ],
      outcomes: [
        'Një identitet i njësuar që ju e tregoni me krenari',
        'Njohje e menjëhershme në çdo pikë kontakti',
        'Leja vizuale për të kërkuar çmime premium',
      ],
      includes: [
        'Pozicionim i markës dhe bazë e mesazhit',
        'Familje logosh dhe sistem tipografik',
        'Paletë ngjyrash dhe art direction',
        'Dokument me udhëzuesin e markës',
        'Brand kit dhe shabllone për rrjetet sociale',
      ],
    },
    {
      slug: 'digital-strategy',
      number: '04',
      icon: 'LineChart',
      title: 'Strategji dixhitale',
      short:
        'Plane marketingu të bazuara në të dhëna dhe ndjekje e performancës — vendime mbi fakte.',
      overview:
        'Shija pa numra është dekor. Ne hartojmë audiencën, kanalet dhe funnel-in, pastaj përcaktojmë treguesit që vërtet shfaqin rritje — që çdo tremujor të jetë vendim, jo hamendje.',
      who: [
        'Marka të gatshme të rriten përtej instinktit dhe improvizimit',
        'Ekipe të pasigurta se cilat kanale meritojnë kohë dhe buxhet',
        'Sipërmarrës që duan një udhërrëfyes të dokumentuar',
      ],
      outcomes: [
        'Një udhërrëfyes i dokumentuar i rritjes me përparësi të qarta',
        'Qartësi për kanalet që e meritojnë vendin e tyre',
        'Vendime mbi të dhëna që ju vërtet mund t’i lexoni',
      ],
      includes: [
        'Analizë e audiencës dhe e konkurrencës',
        'Strategji e kanaleve dhe e funnel-it',
        'Planifikim i kampanjave dhe kalendar i lançimit',
        'Kuadër KPI dhe dashboard raportimi',
        'Rishikime strategjike tremujore',
      ],
    },
    {
      slug: 'websites-ai-automation',
      number: '05',
      icon: 'Cpu',
      title: 'Faqe web & automatizim me AI',
      short:
        'Faqe web të personalizuara, web-app dhe automatizim me AI — të ndërtuara me partnerin tonë teknologjik CloudService.hr.',
      overview:
        'Dukshmëria është vetëm gjysma e rrugës. Herët a vonë një markë ka nevojë për një vend ku vëmendja kthehet në kërkesë — dhe për sisteme që punojnë edhe kur ju jeni prej kohësh offline. Pikërisht kjo lind në partneritet me CloudService.hr: faqe web të personalizuara, web dhe mobile app, asistentë AI dhe automatizime. Pa shabllone, pa ndërtues faqesh.',
      who: [
        'Marka që duan t’i kthejnë një prezencë të bukur në kërkesa të besueshme',
        'Kompani që bëjnë të njëjtat procese me dorë çdo ditë',
        'Sipërmarrës me një ide produkti që kërkon një MVP të vërtetë',
      ],
      outcomes: [
        'Një faqe web që i takon markës tuaj — jo një shablloni',
        'AI dhe automatizimi marrin rutinën: kërkesat, ofertat, ndjekjen',
        'Një produkt që del vërtet live — në javë, jo në tremujorë',
      ],
      includes: [
        'Faqe web, landing page ose web-app të personalizuar',
        'Asistentë AI, këshillues dhe sisteme chat',
        'Automatizim për oferta, lead-e dhe ndjekje',
        'Dashboard CRM dhe administrimi për ekipin tuaj',
        'Aplikacione iOS dhe Android, si edhe platforma SaaS',
        'Flukse pagesash, hosting dhe monitorim — gati për prodhim',
      ],
    },
  ],

  /** value = vlera kanonike në anglisht që ruhet në bazën e të dhënave. */
  serviceOptions: [
    { value: 'Social Media Management', label: 'Menaxhim i rrjeteve sociale', group: 'marketing' },
    { value: 'Content Strategy & Aesthetic', label: 'Strategji e përmbajtjes & estetikë', group: 'marketing' },
    { value: 'Visual Identity & Branding', label: 'Identitet vizual & branding', group: 'marketing' },
    { value: 'Digital Strategy', label: 'Strategji dixhitale', group: 'marketing' },
    { value: 'Website', label: 'Faqe web', group: 'tech' },
    { value: 'Web App', label: 'Web-app', group: 'tech' },
    { value: 'Mobile App', label: 'Aplikacion mobil (iOS / Android)', group: 'tech' },
    { value: 'AI Tool', label: 'Mjet AI / asistent AI', group: 'tech' },
    { value: 'Automation', label: 'Automatizim', group: 'tech' },
    { value: 'CRM / Admin Dashboard', label: 'CRM / dashboard administrimi', group: 'tech' },
    { value: 'SaaS Platform', label: 'Platformë SaaS', group: 'tech' },
    { value: 'E-Commerce', label: 'Dyqan online / e-commerce', group: 'tech' },
    { value: 'Not sure yet', label: 'Nuk kam vendosur ende', group: 'other' },
  ],

  serviceOptionGroups: {
    marketing: 'Marketing & markë',
    tech: 'Faqe web & automatizim me AI',
    other: 'Tjetër',
  },

  /** Këto tipe projektesh shfaqin fushat e buxhetit dhe të afatit. */
  techProjectValues: [
    'Website',
    'Web App',
    'Mobile App',
    'AI Tool',
    'Automation',
    'CRM / Admin Dashboard',
    'SaaS Platform',
    'E-Commerce',
  ],

  budgetOptions: [
    { value: 'Under EUR 3,000', label: 'nën 3.000 €' },
    { value: 'EUR 3,000 - 10,000', label: '3.000 – 10.000 €' },
    { value: 'EUR 10,000 - 25,000', label: '10.000 – 25.000 €' },
    { value: 'EUR 25,000+', label: '25.000 € +' },
    { value: 'Budget open', label: 'Ende e hapur' },
  ],

  timelineOptions: [
    { value: 'ASAP (within 2 weeks)', label: 'Sa më shpejt (brenda 2 javësh)' },
    { value: 'Within 1 month', label: 'Brenda një muaji' },
    { value: '1-3 months', label: '1 – 3 muaj' },
    { value: '3+ months', label: '3+ muaj' },
    { value: 'Timeline open', label: 'Ende e hapur — pres këshillë' },
  ],

  partnership: {
    eyebrow: 'Partneritet teknologjik',
    title: 'Kur marka qëndron, ndërtojmë produktin.',
    lede:
      'Për çdo gjë që kërkon kod, punoj me CloudService.hr — një studio AI dhe automatizimi në Vjenë dhe Zagreb. Unë sjell markën, tekstin dhe estetikën; studio sjell inxhinierinë. Për ju mbetet një person kontakti: unë.',
    partnerLabel: 'Partner teknologjik',
    partnerName: 'CloudService.hr',
    partnerTagline: 'AI Solutions · SaaS Platforms · Mobile Apps · Business Automation',
    partnerClaim: 'Ndërtojmë produkte dixhitale, jo vetëm faqe web.',
    partnerUrl: 'https://cloudservice.hr',
    visitPartner: 'Shiko CloudService.hr',
    capabilities: [
      {
        icon: 'BrainCircuit',
        title: 'AI Solutions',
        body: 'Sisteme AI që marrin procese reale — këshillues, asistentë, njohje dokumentesh.',
      },
      {
        icon: 'Boxes',
        title: 'Platforma SaaS',
        body: 'Nga login-i deri te abonimi: platforma gati për prodhim, jo prototipe.',
      },
      {
        icon: 'Smartphone',
        title: 'Aplikacione mobile',
        body: 'iOS dhe Android që ndihen si aplikacione konsumatore — jo si mjete të brendshme.',
      },
      {
        icon: 'Workflow',
        title: 'Automatizim biznesi',
        body: 'Mjete të brendshme dhe automatizime që i kthejnë ekipit tuaj orët e humbura.',
      },
    ],
    referencesLabel: 'Live në prodhim',
    references: [
      {
        name: 'DealAlert.ai',
        url: 'https://dealalert.ai',
        tag: 'AI SaaS · Asset intelligence',
        body: 'AI dallon oferta makinash dhe pronash nën çmimin e tregut — me aplikacion iOS të vetin dhe faturim përmes Stripe.',
      },
      {
        name: 'HausDesHandys.at',
        url: 'https://hausdeshandys.at',
        tag: 'Retail · AI commerce',
        body: 'Një biznes lokal riparimi i dixhitalizuar plotësisht: konfigurues riparimesh, smart pricing, asistent AI dhe sistem administrimi.',
      },
      {
        name: 'NAAutomobile.at',
        url: 'https://naautomobile.at',
        tag: 'Automotive · Platformë',
        body: 'Platformë premium për tregtinë e automjeteve, me studio fotografike AI, kërkesa WhatsApp-first, financim dhe lead-e blerjeje.',
      },
    ],
    note:
      'Nga biseda e parë deri te produkti i përfunduar: kuptojmë idenë, mprehim konceptin, ndërtojmë MVP-në, integrojmë AI dhe automatizimin, dalim live — dhe pastaj vazhdojmë të përmirësojmë.',
    cta: 'Diskuto një projekt',
    liveLabel: 'Shiko live',
  },

  valueProps: [
    {
      icon: 'Compass',
      title: 'Strategji e personalizuar',
      body: 'Pa prezantime të ricikluara. Çdo strategji lind nga audienca juaj, tregu juaj dhe ambicia juaj.',
    },
    {
      icon: 'Aperture',
      title: 'Një sy redaksional',
      body: 'Shija është aset biznesi. Markën tuaj e drejtojmë ashtu si një revistë drejton kryeartikullin.',
    },
    {
      icon: 'TrendingUp',
      title: 'Zbatim i orientuar nga rezultatet',
      body: 'E bukura është pikënisja. Matim shtrirjen, angazhimin dhe kërkesat — dhe veprojmë sipas atyre që zbulojmë.',
    },
    {
      icon: 'Layers',
      title: 'Ndërtim marke, jo postime',
      body: 'Ndërtojmë marka të njohshme me qëndrim, jo llogari që thjesht mbeten aktive.',
    },
    {
      icon: 'Handshake',
      title: 'Një qasje vërtet personale',
      body: 'Punoni drejtpërdrejt me Romildën. Numër i vogël klientësh, kujdes i afërt, përgjegjësi e vërtetë.',
    },
  ],

  process: [
    {
      step: '01',
      title: 'Kuptojmë',
      body: 'Nisim me një konsultë: audienca juaj, tregu juaj, pozicionimi dhe çfarë e ka frenuar rritjen deri tani.',
    },
    {
      step: '02',
      title: 'Strategjizojmë',
      body: 'Përcaktojmë shtyllat e përmbajtjes, drejtimin vizual dhe planin e kanaleve — të dokumentuara, që asgjë të mos varet nga instinkti.',
    },
    {
      step: '03',
      title: 'Krijojmë',
      body: 'Prodhojmë dhe drejtojmë punën: tekste, vizuale, kampanja. Çdo element lidhet me strategjinë.',
    },
    {
      step: '04',
      title: 'Rritemi',
      body: 'Matim, rafinojmë dhe zgjerojmë atë që funksionon — me raporte të lexueshme dhe rishikime që lëvizin gjërat përpara.',
    },
  ],

  caseStudies: [
    {
      tag: 'Rritje e angazhimit',
      metric: '+ / –',
      title: 'Nga një feed i heshtur në bisedë të vazhdueshme',
      body: 'Rindërtim i shtyllave të përmbajtjes dhe një ritëm publikimi i projektuar për t’i kaluar audiencën nga rrëshqitja pasive në angazhim aktiv.',
      status: 'Studimi i rastit në përgatitje',
    },
    {
      tag: 'Përmirësim i shtrirjes',
      metric: '+ / –',
      title: 'Të arrijmë dhomat e duhura, në mënyrë organike',
      body: 'Strategji zbulueshmërie dhe formatesh e fokusuar në shtrirje të kualifikuar — llogaritë që vërtet kthehen në kërkesa.',
      status: 'Studimi i rastit në përgatitje',
    },
    {
      tag: 'Pozicionim i markës',
      metric: '+ / –',
      title: 'Një ripozicionim që ngriti çmimin',
      body: 'Identiteti, mesazhi dhe art direction të rindërtuara, që marka të zinte me besim një nivel më premium.',
      status: 'Studimi i rastit në përgatitje',
    },
    {
      tag: 'Transformim vizual',
      metric: 'Para / Pas',
      title: 'Një feed i rindërtuar si faqe reviste',
      body: 'Rinovim i plotë vizual: paletë, kompozim dhe ritëm i grid-it të trajtuara si një narrativë e vazhdueshme redaksionale.',
      status: 'Studimi i rastit në përgatitje',
    },
  ],

  testimonials: [
    {
      quote:
        'Romilda nuk e bëri thjesht përmbajtjen tonë më të bukur — na dha një qëndrim. Për herë të parë marka ime ndihet se i takon çmimit që kërkojmë.',
      name: 'Emri i klientit',
      role: 'Fondatore, kategori marke',
      placeholder: true,
    },
    {
      quote:
        'Strategjia ishte konkrete, e dokumentuar dhe vërtet e jona. Brenda javësh shtrirja u rrit dhe, më e rëndësishmja, po pyesnin njerëzit e duhur.',
      name: 'Emri i klientit',
      role: 'Përgjegjës marketingu, kategori marke',
      placeholder: true,
    },
    {
      quote:
        'Puna me të është si të kesh një drejtor kreativ dhe një strateg në të njëjtën bisedë. Asgjë nuk lihet në hamendje, asgjë nuk duket e rastësishme.',
      name: 'Emri i klientit',
      role: 'Pronar, kategori marke',
      placeholder: true,
    },
    {
      quote:
        'Ka një sy redaksional që nuk mësohet, të shoqëruar me një mendje shumë të kthjellët për numrat. Ky kombinim është i rrallë dhe duket në rezultate.',
      name: 'Emri i klientit',
      role: 'Bashkëfondator, kategori marke',
      placeholder: true,
    },
    {
      quote:
        'Dorëzuam një llogari të papërputhshme dhe marrëm një markë. Vetëm raportimi ndryshoi mënyrën si vendosim brenda ekipit.',
      name: 'Emri i klientit',
      role: 'Drejtor, kategori marke',
      placeholder: true,
    },
  ],

  photo: {
    homeHeroAlt:
      'Romilda, fondatorja e Romilda Marketing Hub, fotografuar në një studio redaksionale',
    homeHeroCaption: 'Romilda · Fondatore & Stratege',
    homeAboutAlt: 'Portret i Romildës',
    homeAboutCaption: 'Fondatore · Stratege · Sy redaksional',
    homeEditorialAlt: 'Portret redaksional i Romildës në studio me dritë gjeometrike',
    homeEditorialCaption: 'Drejtim redaksional',
    servicesHeroAlt: 'Romilda fotografuar në studio me hije gjeometrike',
    servicesHeroCaption: 'Strategji · Përmbajtje · Identitet · Rritje',
    aboutHeroAlt: 'Romilda Bahollari, fondatorja e Romilda Marketing Hub',
    aboutHeroCaption: 'Romilda · Fondatore',
    aboutPortraitAlt: 'Portret i Romildës me këmishë të bardhë',
    aboutApproachAlt: 'Portret redaksional i Romildës para një mure studioje',
    aboutApproachCaption: 'Strategjia takon art direction',
    contactHeroAlt: 'Romilda, fondatorja e Romilda Marketing Hub',
    contactHeroCaption: 'Do të bisedoni drejtpërdrejt me Romildën',
  },

  home: {
    hero: {
      eyebrow: 'Studio premium e marketingut dixhital',
      titleBefore: 'Strategji që e bën markën tuaj ',
      titleAccent: 'të pashmangshme',
      titleAfter: '.',
      lede:
        'Strategji premium e përmbajtjes, rritje në rrjetet sociale dhe branding për biznese moderne që janë gati të ngrenë prezencën e tyre — të ndërtuara me sy redaksional dhe të matura në rezultate.',
      statViews: 'shikime të gjeneruara në muaj',
      statReach: 'llogari të arritura',
      nowOffering: 'Tani në ofertë',
      aiTeaser: 'Romilda AI — orientim strategjik i menjëhershëm',
    },
    services: {
      eyebrow: 'Çfarë bëjmë',
      title: 'Pesë disiplina, një markë e njësuar.',
      lede:
        'Çdo projekt lind rreth pozicionimit tuaj — jo rreth një pakete. Zgjidhni disiplinën që ju duhet, ose lërna të ndërtojmë të gjithë sistemin.',
    },
    about: {
      eyebrow: 'Njihuni me Romildën',
      title: 'Marketing i ndërtuar mbi strategji — dhe i përkryer me shije.',
      p1: 'Krijova Romilda Marketing Hub sepse vazhdimisht shihja të njëjtën boshllëk: agjenci që raportonin numra pa pasur sy, dhe kreativë me punë të bukur pa strategji pas tyre. Markave po u kërkohej të zgjidhnin.',
      p2: 'Puna ime qëndron në mes. Planifikoj si strateg — audiencë, pozicionim, funnel, të dhëna — dhe drejtoj si redaktore, duke e trajtuar çdo feed si një botim me qëndrim. Rezultati është një markë që duket e menduar dhe performon si e projektuar.',
      quote:
        'Shija nuk është dekor. Është mënyra më e shpejtë për të sinjalizuar se ju vlen më shumë.',
      readStory: 'Lexo historinë e plotë',
    },
    why: {
      eyebrow: 'Pse me ne',
      title: 'Diferenca është në mendimin, jo në shabllonin.',
      lede: 'Numër i vogël klientësh, kujdes i afërt dhe një standard që nuk e ulim.',
      aiTag: 'E re',
      aiTitle: 'Romilda AI',
      aiBody:
        'Pyetni asistentin tonë të strategjisë për një lexim të menjëhershëm të përmbajtjes, brandingut ose rritjes tuaj — para se të rezervoni një bisedë.',
      aiHint: 'Hapni widget-in, poshtë djathtas',
    },
    results: {
      eyebrow: 'Rezultate',
      title: 'Rritje që mund ta tregojmë.',
      lede:
        'Studimet e plota të rasteve janë në dokumentim. Këtu është forma e punës — çdo kartë do të zëvendësohet me numra klientësh dhe vizuale para/pas.',
      sideNote:
        'Çdo rezultat nis njësoj — një strategji e dokumentuar, pastaj art direction që e bën të panjollosur.',
    },
    testimonials: {
      eyebrow: 'Besim',
      title: 'Çfarë thonë klientët.',
      lede:
        'Citimet më poshtë janë vendmbajtëse — shkruar në tonin që presim, gati për t’u zëvendësuar me fjalë reale të klientëve.',
    },
    process: {
      eyebrow: 'Procesi',
      title: 'Si punojmë bashkë.',
      lede: 'Katër faza të përcaktuara qartë, që ju të dini gjithmonë çfarë vjen më pas.',
    },
    bottom: {
      prefix: 'Preferoni të lexoni më parë?',
      servicesLink: 'Shiko shërbimet',
      aboutLink: 'lexo historinë e Romildës',
    },
  },

  servicesPage: {
    hero: {
      eyebrow: 'Shërbimet',
      titleLines: ['Pesë disiplina.', 'Një markë në nivel.'],
      lede:
        'Merrni një disiplinë ose sistemin e plotë. Sido që të jetë, strategjia është e dokumentuar, art direction është e qëllimshme dhe rezultatet matën — kurrë hamendësohen.',
      indexNavLabel: 'Indeksi i shërbimeve',
    },
    stage: {
      scrollCue: 'Rrëshqitni për të zbuluar',
      progressAria: 'Ecuria e shërbimeve',
      goTo: 'Shko te {title}',
    },
    whoLabel: 'Për kë është',
    outcomesLabel: 'Rezultate të pritshme',
    includesLabel: 'Çfarë përfshihet',
    process: {
      eyebrow: 'Procesi',
      title: 'Si duket puna bashkë.',
      lede:
        'Pavarësisht shërbimit që zgjidhni, rruga është e njëjtë — e qartë, e dokumentuar dhe në bashkëpunim.',
    },
    finalCta: {
      eyebrow: 'Hapi tjetër',
      title: 'Nuk jeni i sigurt cili shërbim ju duhet?',
      body:
        'Rezervoni një konsultë dhe e hartojmë bashkë — ose pyetni Romilda AI për një lexim të menjëhershëm para se të angazhoheni për një bisedë.',
    },
  },

  aboutPage: {
    hero: {
      eyebrow: 'Rreth meje',
      titleLines: ['Ndërtoj marka që dukën', 'aq të menduara sa janë.'],
      lede:
        'Unë jam Romilda — fondatorja e Romilda Marketing Hub, një studio për marka që duan strategji dhe shije në të njëjtën dhomë. Puna ime ndërthur mendimin e strukturuar të marketingut me art direction redaksional të nivelit të modës së lartë.',
    },
    story: {
      eyebrow: 'Historia',
      title: 'Si nisi studio.',
      p1: 'Në marketing nisa si shumë të tjerë — me tabela, raporte dhe kalendarë kampanjash. Mësova shpejt se numrat mund t’i rritja. Më frustronte të shihja marka me potencial të vërtetë që prezantoheshin në një mënyrë që u ulte gjithçka vlenin.',
      p2: 'Njëkohësisht më tërhiqte moda dhe puna redaksionale — mënyra si një revistë komunikon një botëkuptim të tërë në një faqe të vetme. U bë e qartë se të dyja disiplinat i takonin njëra-tjetrës: rreptësia e strategjisë, siguria e art direction-it të mirë.',
      p3: 'Romilda Marketing Hub ekziston për t’i mbajtur të dyja. Planifikojmë siç duhet, dukemi të jashtëzakonshëm dhe i mbajmë të dyja përgjegjëse ndaj njëra-tjetrës. Sot puna arrin mbi njëqind mijë llogari në muaj — jo me shkurtime, por me qëndrueshmëri dhe një standard shumë të lartë për çdo gjë që publikohet.',
      quote:
        'Nuk dua që marka juaj të dukët si e të gjithëve, duke performuar pak më mirë. Dua që të dukët si e askujt tjetër — dhe të performojë pikërisht për këtë arsye.',
      cite: 'Romilda, Fondatore',
      numbersLabel: 'Në numra',
    },
    philosophy: {
      eyebrow: 'Filozofia',
      title: 'Katër bindje që formësojnë çdo projekt.',
      items: [
        {
          title: 'Gjithmonë strategjia e para',
          body: 'Para se të krijohet një element i vetëm, pajtohemi për kujt i drejtohemi, çfarë duam të besojë dhe si do e dimë se funksionoi. Kreativiteti pa këtë bazë është dekor i shtrenjtë.',
        },
        {
          title: 'Estetika është komerciale',
          body: 'Si duket një markë përcakton sa mund të kërkojë. Art direction-in e trajtojmë si levë të ardhurash, jo si përfundim dekorativ — dhe e mbajmë në standard redaksional.',
        },
        {
          title: 'Qëndrueshmëria mund më shumë sesa intensiteti',
          body: 'Një markë ndërtohet nga qindra vendime të përputhura, jo nga një moment viral. Projektojmë sisteme që mund t’i mbani, pastaj i rafinojmë pa ndalim.',
        },
        {
          title: 'Më pak klientë, më shumë kujdes',
          body: 'Numri i klientëve mbetet i vogël me qëllim. Punoni drejtpërdrejt me mua — jo me një account manager që kalon vendime nëpër tre inbox-e.',
        },
      ],
    },
    approach: {
      eyebrow: 'Çfarë të pritni',
      title: 'E qartë, e afërt dhe në standard.',
      lede:
        'Puna me një studio të vogël duhet të ndihet ndryshe nga puna me një agjenci. Ja çfarë do të thotë kjo në praktikë.',
      items: [
        'Një strategji e dokumentuar që mund t’i shërbejë vërtet çdo brifi',
        'Art direction e mbajtur në standard redaksional',
        'Raportim i qartë me interpretim, jo dashboard-e të papërpunuara',
        'Akses i drejtpërdrejtë te Romilda gjatë gjithë projektit',
        'Rekomandime të sinqerta — përfshirë kur duhet bërë më pak',
      ],
      cta: 'Nisni me një konsultë',
    },
    finalCta: {
      eyebrow: 'Të bisedojmë',
      title: 'Nëse kështu doni të punoni — nisim.',
      body:
        'Rezervoni një konsultë dhe sillni sfidën tuaj aktuale. Do të ikni nga biseda me një drejtim më të qartë, pavarësisht nëse punojmë bashkë.',
    },
  },

  contactPage: {
    hero: {
      eyebrow: 'Kontakt',
      titleLines: ['Të ndërtojmë diçka', 'që vlen t’i hidhet një sy.'],
      lede:
        'Tregoni pak për markën tuaj dhe ku ndiheni bllokuar. Do të ikni nga konsulta me një drejtim më të qartë — pavarësisht nëse përfundojmë duke punuar bashkë.',
      emailLabel: 'E-mail',
      whatsappLabel: 'WhatsApp',
      responseLabel: 'Kohë përgjigjeje',
      responseValue: 'Brenda 2 ditësh pune',
    },
    form: {
      eyebrow: 'Kërkesë për konsultë',
      title: 'Tregoni për markën tuaj.',
      lede:
        'Disa pyetje të shkurtra. Sa më konkret të jeni, aq më e vlefshme bëhet biseda e parë.',
      nameLabel: 'Emri juaj *',
      namePlaceholder: 'Elena Rossi',
      brandLabel: 'Emri i biznesit / markës',
      brandPlaceholder: 'Casa Rossi',
      emailLabel: 'E-mail *',
      emailPlaceholder: 'ju@markajuaj.com',
      serviceLabel: 'Shërbimi i interesit',
      servicePlaceholder: 'Zgjidhni një shërbim',
      budgetLabel: 'Kuadri i buxhetit',
      budgetPlaceholder: 'Zgjidhni buxhetin',
      timelineLabel: 'Afati',
      timelinePlaceholder: 'Zgjidhni afatin',
      projectHint:
        'Faqet web, aplikacionet dhe automatizimet ndërtohen bashkë me partnerin tonë teknologjik CloudService.hr. Buxheti dhe afati ndihmojnë për një vlerësim të parë realist.',
      challengeLabel: 'Sfida juaj më e madhe aktuale *',
      challengePlaceholder:
        'Për shembull: Instagram-i ynë duket i papërputhshëm dhe nga ai marrim pothuajse asnjë kërkesë.',
      privacy: 'Të dhënat tuaja përdoren vetëm për t’u përgjigjur kësaj kërkese.',
      submit: 'Dërgo kërkesën',
      errors: {
        name: 'Ju lutemi shkruani emrin tuaj.',
        email: 'Ju lutemi shkruani një adresë e-mail të vlefshme.',
        challenge: 'Një ose dy fjali për sfidën tuaj na ndihmojnë të përgatitemi.',
        incomplete: 'Ju lutemi plotësoni fushat e theksuara.',
        failed: 'Nuk arritëm ta dërgojmë tani. Ju lutemi shkruani drejtpërdrejt me e-mail.',
      },
      toastSuccess: 'Kërkesa u pranua — Romilda do të kontaktojë.',
    },
    success: {
      title: 'Faleminderit, {name}.',
      body: 'Kërkesa juaj është te Romilda. Ajo lexon personalisht çdo mesazh dhe do t’i përgjigjet {email} brenda dy ditësh pune.',
      whileYouWait: 'Ndërkohë që pritni',
      continueWhatsapp: 'Vazhdo në WhatsApp',
      sendAnother: 'Dërgo një kërkesë tjetër',
    },
    faq: [
      {
        q: 'Çfarë ndodh pasi e dërgoj këtë?',
        a: 'Romilda lexon personalisht çdo kërkesë dhe përgjigjet brenda dy ditësh pune me hapat e mëtejshëm ose me një propozim orari për bisedë.',
      },
      {
        q: 'Çfarë përfshin konsulta?',
        a: 'Pozicionimin tuaj, audiencën tuaj, çfarë e ka frenuar rritjen dhe një pamje të sinqertë se cili shërbim do bëjë diferencën e parë.',
      },
      {
        q: 'A i tregoni çmimet përpara bisedës?',
        a: 'Vëllimi i punës përshtatet me markën tuaj, ndaj çmimet diskutohen në konsultë sapo dimë çfarë kërkon vërtet puna.',
      },
    ],
    aiTeaser: {
      title: 'Doni një lexim të menjëhershëm më parë?',
      body:
        'Pyetni Romilda AI — poshtë djathtas në ekranin tuaj — për një drejtim strategjik të parë në më pak se një minutë.',
    },
    bottom: {
      prefix: 'Preferoni të shikoni më parë?',
      servicesLink: 'Shiko shërbimet',
      aboutLink: 'lexo historinë',
    },
  },

  notFound: {
    title: 'Kjo faqe ka ndryshuar vend.',
    body: 'Faqja që kërkonit nuk është këtu. Të kthehemi te diçka e dobishme.',
    home: 'Kthehu në ballinë',
  },

  ctaBlock: {
    eyebrow: 'Të nisim',
    title: 'Gati për të ngritur markën tuaj?',
    body:
      'Rezervoni një konsultë dhe të ndërtojmë një strategji të përshtatur për vizionin tuaj — audiencën tuaj, estetikën tuaj, ambicien tuaj.',
  },

  widget: {
    launcherTitle: 'Romilda AI',
    launcherSubtitle: 'Strategji e menjëhershme',
    launcherAria: 'Hap Romilda AI — orientim strategjik i menjëhershëm',
    panelAria: 'Romilda AI',
    welcomeTitle: 'Mirë se vini te Romilda AI.',
    welcomeBody:
      'Tregoni pak për markën tuaj dhe do ju ndihmoj të dalloni mundësinë tuaj të radhës për rritje.',
    startHere: 'Ose nisni këtu',
    thinking: 'Po mendon',
    placeholder: 'Tregoni për markën tuaj…',
    inputAria: 'Mesazh për Romilda AI',
    sendAria: 'Dërgo mesazhin',
    disclaimer: 'Orientim strategjik, nuk zëvendëson një konsultë të plotë.',
    resetAria: 'Nis një bisedë të re',
    closeAria: 'Mbyll Romilda AI',
    emailInstead: 'Shkruani me e-mail në vend të kësaj',
    unavailable:
      'Romilda AI është përkohësisht e paarritshme. Provoni përsëri ose shkruani te {email}.',
    quickActions: [
      {
        id: 'audit',

        label: 'Vlerëso strategjinë',
        prompt:
          'Do të dëshiroja një vlerësim të strategjisë tim aktuale të marketingut. Nga ku duhet të nisim?',
      },
      {
        id: 'ideas',

        label: 'Ide për përmbajtje',
        prompt: 'Më duhen ide të freskëta përmbajtjeje për markën tim.',
      },
      {
        id: 'website',

        label: 'Faqe web & automatizim',
        prompt:
          'Më duhet një faqe web e re ose dua të automatizoj procese me AI. Çfarë është e mundur?',
      },
      {
        id: 'instagram',

        label: 'Përmirëso Instagram-in',
        prompt: 'Si mund të përmirësoj prezencën tim në Instagram?',
      },
      {
        id: 'branding',

        label: 'Ndihmë me brandingun',
        prompt: 'Më duhet ndihmë me brandingun dhe identitetin vizual.',
      },
      {
        id: 'audience',

        label: 'Rrit audiencën',
        prompt: 'Dua të rrit audiencën tim. Në çfarë duhet të fokusohem?',
      },
      {
        id: 'services',

        label: 'Zbulo shërbimet',
        prompt: 'Cili nga shërbimet tuaja do më përshtatej më mirë?',
      },
    ],
    lead: {
      eyebrow: 'Vazhdo me Romildën',
      title: 'Ta kaloj kontaktin tuaj te Romilda?',
      body: 'Ajo do kthehet me një hap konkret të radhës — pa sekuenca automatike.',
      namePlaceholder: 'Emri juaj',
      emailPlaceholder: 'Adresa e-mail',
      focusPlaceholder: 'Në çfarë jeni fokusuar?',
      dismissAria: 'Mbyll',
      submit: 'Dërgo te Romilda',
      error: 'Ju lutemi shtoni emrin dhe një e-mail të vlefshëm.',
      failed: 'Nuk arritëm ta ruajmë tani. Ju lutemi provoni përsëri.',
      toast: 'Faleminderit — Romilda do të kontaktojë personalisht.',
      saved: 'Të dhënat tuaja janë te Romilda. Ajo do të kontaktojë personalisht.',
    },
  },

  admin: {
    login: {
      eyebrow: 'Zonë e brendshme',
      title: 'Paneli i lead-eve',
      body: 'Shkruani fjalëkalimin e panelit për të shikuar lead-et dhe bisedat me AI.',
      passwordLabel: 'Fjalëkalimi',
      passwordPlaceholder: 'Fjalëkalimi i panelit',
      submit: 'Hyr',
      signingIn: 'Po hyn…',
      wrong: 'Ky fjalëkalim nuk është i saktë.',
      failed: 'Hyrja nuk u realizua. Ju lutemi provoni përsëri.',
      empty: 'Ju lutemi shkruani fjalëkalimin.',
    },
    eyebrow: 'E brendshme',
    title: 'Lead-e të mbledhura',
    subtitle:
      'Kërkesa nga formulari i konsultës dhe të dhëna të ndara brenda Romilda AI.',
    signOut: 'Dil',
    refresh: 'Rifresko',
    exportCsv: 'Eksporto CSV',
    exporting: 'Po eksportohet…',
    exportFailed: 'CSV-ja nuk u eksportua.',
    stats: {
      total: 'Lead-e gjithsej',
      unread: 'Të reja / të palexuara',
      form: 'Nga formulari',
      ai: 'Nga Romilda AI',
    },
    filters: {
      all: 'Të gjitha',
      new: 'Të reja',
      form: 'Formulari i kontaktit',
      ai: 'Romilda AI',
    },
    searchPlaceholder: 'Kërko emër, e-mail, markë…',
    searchAria: 'Kërko lead-e',
    loadError: 'Lead-et nuk u ngarkuan. Ju lutemi provoni përsëri.',
    empty: {
      title: 'Ende pa lead-e',
      body:
        'Kërkesat nga formulari i konsultës dhe të dhënat e mbledhura nga Romilda AI do shfaqen këtu.',
    },
    emptyFiltered: {
      title: 'Asgjë nuk përputhet me filtrin',
      body: 'Provoni një filtër tjetër ose fshini kërkimin.',
    },
    lead: {
      unnamed: 'Vizitor pa emër',
      sourceAi: 'Romilda AI',
      sourceForm: 'Formulari i kontaktit',
      interest: 'Interesi',
      challenge: 'Sfida e tyre',
      summary: 'Përmbledhje AI',
      platform: 'Platforma',
      budget: 'Kuadri i buxhetit',
      timeline: 'Afati',
      message: 'Mesazhi',
      viewDetails: 'Shiko detajet',
      newBadge: 'E re',
    },
    detail: {
      title: 'Detajet e lead-it',
      contact: 'Kontakt',
      noEmail: 'Pa e-mail',
      conversation: 'Bisedë me Romilda AI',
      conversationEmpty: 'Ky lead erdhi nga formulari i kontaktit — pa bisedë AI.',
      conversationLoading: 'Po ngarkohet biseda…',
      visitor: 'Vizitor',
      assistant: 'Romilda AI',
      messagesCount: '{count} mesazhe',
      close: 'Mbyll',
      emailAction: 'Përgjigju me e-mail',
      whatsappAction: 'Hap WhatsApp',
      statusLabel: 'Statusi',
      copyEmail: 'Kopjo e-mailin',
      copied: 'E-maili u kopjua',
    },
    status: {
      new: 'E re',
      read: 'E lexuar',
      contacted: 'E kontaktuar',
      archived: 'E arkivuar',
    },
    statusUpdated: 'Statusi u përditësua',
    statusFailed: 'Statusi nuk u përditësua.',
  },

  seo: {
    '/': {
      title:
        'Romilda Marketing Hub | Strategji premium e përmbajtjes, rritje në rrjetet sociale & branding',
      description:
        'Romilda Marketing Hub është një agjenci premium e marketingut dixhital për marka me shije — strategji e përmbajtjes, menaxhim i rrjeteve sociale, identitet vizual dhe strategji dixhitale. 500.000+ shikime dhe 160.000+ llogari të arritura në muaj. Rezervoni një konsultë.',
      keywords:
        'agjenci marketingu dixhital, strategji e përmbajtjes, menaxhim rrjetesh sociale, identitet vizual, agjenci brandingu, rritje në Instagram, marketing redaksional, agjenci premium marketingu, Romilda Marketing Hub',
    },
    '/services': {
      title:
        'Shërbimet | Menaxhim rrjetesh sociale, strategji përmbajtjeje, branding & strategji dixhitale',
      description:
        'Pesë disiplina, një markë në nivel: menaxhim i rrjeteve sociale, strategji e përmbajtjes dhe estetikë, identitet vizual dhe branding, strategji dixhitale mbi të dhëna, si edhe faqe web të personalizuara dhe automatizim me AI. Për kë është çdo shërbim, çfarë rezultatesh pritën dhe çfarë përfshihet.',
      keywords:
        'shërbime menaxhimi rrjetesh sociale, agjenci strategjie përmbajtjeje, dizajn identiteti marke, logo dhe udhëzues marke, strategji marketingu dixhital, strategji përmbajtjeje Instagram, ndërtim faqe web të personalizuar, automatizim me AI, automatizim biznesi',
    },
    '/about': {
      title: 'Rreth Romildës | Fondatore, stratege & art directore redaksionale',
      description:
        'Njihuni me Romildën — fondatorja e Romilda Marketing Hub. Strategji e strukturuar marketingu e ndërthurur me art direction redaksional të nivelit të modës së lartë, për marka që duan shije dhe rezultate në të njëjtën dhomë.',
      keywords:
        'Romilda Bahollari, stratege marketingu, art direction redaksional, agjenci marke personale, studio marketingu e drejtuar nga fondatorja',
    },
    '/contact': {
      title: 'Rezervo një konsultë | Kontakto Romilda Marketing Hub',
      description:
        'Rezervoni një konsultë me Romilda Marketing Hub. Tregoni për markën tuaj dhe sfidën tuaj më të madhe aktuale dhe marrni një drejtim strategjik të përshtatur. Kontaktoni me formular, e-mail ose WhatsApp.',
      keywords:
        'rezervo konsultë marketingu, kontakto agjenci marketingu, bisedë për strategji marketingu, punëso menaxher rrjetesh sociale',
    },
    '/leads': {
      title: 'Lead-e | Romilda Marketing Hub',
      description: 'Përmbledhje e brendshme e lead-eve për Romilda Marketing Hub.',
      noindex: true,
    },
    '*': {
      title: 'Faqja nuk u gjet | Romilda Marketing Hub',
      description:
        'Faqja që kërkonit nuk është këtu. Kthehuni te Romilda Marketing Hub për të shikuar shërbimet ose për të rezervuar një konsultë.',
      noindex: true,
    },
  },

  ldDescription:
    'Agjenci premium e marketingut dixhital që ofron zgjidhje marketingu të personalizuara, strategji të përmbajtjes, rritje në rrjetet sociale, identitet vizual dhe zhvillim marke.',
};

export default sq;
